import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { mapState } from "vuex";
import { INewContractState } from "../../new-contract-vuex-store";
import { ICustomerViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { CustomerTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import ValidationMessage from "../../Default/common/validation-message.vue";
import { ValidationErrors } from "../../new-contract-vue";

@Component({
    computed: mapState({
        contract: (state: INewContractState) => state.contract,
        customer: (state: INewContractState) => state.contract.Customer,
        company: (state: INewContractState) => state.contract.Company,
    }),
    components: {
        ValidatedFormGroup,
        ValidationMessage
    },
})

export default class Authentication extends Vue {
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get customer(): ICustomerViewModel { return this.$store.state.contract.Customer; }
    get authenticateQuestionAccepted(): boolean { return this.contract.AuthenticateQuestionAccepted }
    validationErrors: ValidationErrors = new ValidationErrors();
    
    @Prop()
    public testMode: boolean;

    @Prop()
    public showAuthentication: boolean;

    @Prop()
    public hideAuthenticationForcedText: boolean;

    @Prop({ default: false })
    public moving: boolean;

    @Prop({ default: null })
    public redirectUrl: string;

    @Prop({ default:"/NewContract/Contract/AuthenticationStart"})
    public newcontractAuthentication: boolean;

    @Prop({ default: "/MovingContract/MovingContract/AuthenticationStart" })
    public movingAuthentication: boolean;

    @Prop({ default: false })
    public saveAndFinishProcess: boolean;

    constructor() {
        super();
    }

    @Emit()
    authenticate() {
        event.preventDefault();
        console.log("authenticate() called from authentication.ts");
        const service = "OPTunnistus";

        let baseUrl = this.newcontractAuthentication;
        if (this.moving) {
            baseUrl = this.movingAuthentication;
        }
        let url = baseUrl  + "?external=false";
        if (this.testMode) {
            const testPin = this.customer.Pin;
            const testPinInputValue = (document.getElementById('test-pin') as HTMLInputElement).value

            //console.log("testpin ", testPin)
            //console.log("testPinInputValue ", testPinInputValue)

            if (testPin != null) {
                url += "&testPin=" + testPinInputValue;
            }
        }
        if (service !== null) {
            url += "&service=" + service;
        }
        if (this.redirectUrl !== null) {
            url += "&redirectUrl=" + this.redirectUrl;
        }
        if (this.saveAndFinishProcess) {
            url += "&finish=true";
        }
        window.location.href = url;
        return false;

    }

    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;

    handleBankEvent() {
        //event.preventDefault()
        const bank = "";//event.currentTarget.getAttribute("id");
        const service = "optunnistus";// event.currentTarget.getAttribute("data-service");
        let baseUrl = this.newcontractAuthentication;
        if (this.moving) {
            baseUrl = this.movingAuthentication;
        }
        let url = baseUrl + "?bank=" + bank + "&external=false";
        if (this.testMode) {
            const testPin = this.customer.Pin;
            if (testPin != null && testPin !== "") {
                url += "&testPin=" + testPin;
            }
        }
        if (service !== null) {
            url += "&service=" + service;
        }
        if (this.redirectUrl !== null) {
            url += "&redirectUrl=" + this.redirectUrl;
        }
        if (this.saveAndFinishProcess) {
            url += "&finish=true";
        }
        window.location.href = url;
        return false;
    }
}